import { AssistantContextSubType } from '../types.js';
import { EVERYTHING_CONTEXT_INITIAL_MESSAGE } from '../constants.js';
import { getIsResourceMimeTypeSupportedByAssistant } from './getIsResourceMimeTypeSupportedByAssistant.js';
import { getDisplayKind } from '../../resources/utils/getDisplayKind.js';

const getInitialContextMessageContent = (args) => {
  if ([
    AssistantContextSubType.Everything,
    AssistantContextSubType.Connection,
    AssistantContextSubType.Space,
    AssistantContextSubType.Folder,
    AssistantContextSubType.Selection
  ].includes(args.subType)) {
    return EVERYTHING_CONTEXT_INITIAL_MESSAGE.content;
  }
  if (args.subType === AssistantContextSubType.File) {
    const isSupported = getIsResourceMimeTypeSupportedByAssistant(args.resource.mimeType);
    const displayKind = getDisplayKind(args.resource);
    if (!isSupported) {
      return `I can't understand ${displayKind} yet :(`;
    } else {
      return `Ask me anything about this ${displayKind}.`;
    }
  }
};

export { getInitialContextMessageContent };
//# sourceMappingURL=getInitialContextMessage.js.map
